export default "__VITE_ASSET__DFVgYErW__"